import { Button, List, Stack, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import PatientIntake from "./components/PatientIntake";
import WhiteCard from "../WhiteCard";
import { useGetPatientVisitsQuery } from "src/api/services/onlineVisitsApi";
import UpdateOnlineVisit from "../Modals/UpdateOnlineVisit";
import { useManageModal } from "src/hooks/useManageModal";
import { OnlineVisit } from "src/api/types";
import { usePatientIntakesModal } from "src/context/PatientIntakesModalProvider";

interface Props {
  patientId: number;
  patientEmail?: string;
  patientStatus: string | null;
  allowActions?: boolean;
}
const PatientIntakes = ({
  patientId,
  patientEmail,
  patientStatus,
  allowActions = false,
}: Props) => {
  const [open, { handleClose, handleOpen }] = useManageModal();
  const [expanded, setExpanded] = useState<string | null>(null);
  const { data } = useGetPatientVisitsQuery({ patientId, sort: true });
  const [visit, setVisit] = useState<OnlineVisit | null>(null);
  const { openCreateVisitModal } = usePatientIntakesModal();
  const [blowUp, setBlowUp] = useState<boolean>(false);

  const handleOpenModal = useCallback(
    (visitId: OnlineVisit | null) => {
      setVisit(visitId);
      handleOpen();
    },
    [handleOpen],
  );

  const handleCloseModal = useCallback(() => {
    setVisit(null);
    handleClose();
  }, [handleClose]);

  const visits = useMemo(() => {
    if (data == null) return [];
    return data;
  }, [data]);

  const handleExpanded = useCallback((newExpanded: string | null) => {
    setExpanded(newExpanded);
  }, []);

  return (
    <>
      <WhiteCard
        width="320px"
        maxHeight={blowUp ? "600px" : "315px"}
        gap={1}
        sx={{
          paddingTop: "20px",
          paddingBottom: "20px",
          overflow: "auto",
        }}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="subtitle2">PATIENT INTAKES</Typography>
          {allowActions ? (
            <Button
              variant="text"
              sx={{ ml: "auto" }}
              onClick={() => openCreateVisitModal(patientId)}
            >
              {" "}
              + Create
            </Button>
          ) : null}
        </Stack>
        <List>
          {visits.length > 0 ? (
            visits.map((visit) => (
              <PatientIntake
                patientStatus={patientStatus}
                intake={visit}
                key={visit.id}
                expanded={expanded}
                onExpand={handleExpanded}
                onUpdate={handleOpenModal}
                patientEmail={patientEmail || ""}
                blowUp={blowUp}
                setBlowUp={setBlowUp}
              />
            ))
          ) : (
            <Typography>Patient has no intakes at this time.</Typography>
          )}
        </List>
      </WhiteCard>
      <UpdateOnlineVisit open={open} onClose={handleCloseModal} visit={visit} />
    </>
  );
};

export default PatientIntakes;
